<div style="width: 75%">
    <snelstart-ui-alert type="info">
        Voor het berekenen van het rendement op vermogen (bezittingen en schulden) in box 3 wordt standaard een fictief
        rendement berekend. Het is mogelijk om daarnaast het werkelijk rendement in te vullen. Dat doe je door bij de
        bezittingen en schulden extra gegevens hiervoor invullen. We noemen dit de <b>OWR-gegevens</b>. 'OWR' staat voor
        Opgaaf Werkelijk Rendement. Daarmee wordt dan het werkelijk rendement berekend. Bij de berekening van de
        verschuldigde inkomstenbelasting over box 3 wordt gerekend met het laagste van het fictieve en werkelijke
        rendement.
        <br/><br/>

        Kies hieronder 'Ja' als je (ook) het werkelijk rendement wilt berekenen. <br/>

    </snelstart-ui-alert>
</div>


<form [formGroup]="owrFg">

    <div class="row align-items-start pt-3">
        <div class="col-6">
            <p>
                Werkelijk rendement berekenen door de OWR-gegevens in te vullen?
            </p>
        </div>
        <div class="col-6">
            <snelstart-ui-select-form-control
                    (change)="saveForm()"
                    [options]="optionsJaNee"
                    class="custom-input-150"
                    formControlName="berekenWerkelijkRendement"
                    id="berekenWerkelijkRendement"
            ></snelstart-ui-select-form-control>
        </div>
    </div>

    @if (this.owrFg.get('berekenWerkelijkRendement')?.value === true) {
        <p>Vul hierna bij de bezittingen en schulden de OWR-gegevens via de button "<b>+ OWR</b>'.</p>
    }
</form>



